import React from 'react';
import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'
import LowerNavbar from '../../learning/california/california_classes';
import Uganda from './uganda';
import Uganda_baby2_subjects from './uganda_baby2_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_baby2 = ( ) => {

return (
    <>
<TopNavbar />
    <Uganda />
    <International_countries />
<Uganda_baby2_subjects />  
  
<Outlet />
   

</>
  );
}

export default Uganda_baby2;
